
import { defineComponent } from "vue";
import router from "@/router";
import { IPiarModel } from "@/interfaces/modules";
// Ajusta la ruta del servicio según tu estructura real
import PiarService from "@/api/Piar/PiarService";

export default defineComponent({
    name: "PiarContent",
    data() {
        return {
            form: {
                dialog: false,
                record: {} as IPiarModel,
            },
            table: {
                filters: { search: "" },
                currentPage: 1,
                loading: false,
                headers: [
                    { key: "StudentName", label: "Estudiante", sortable: true },
                    { key: "CourseGroupName", label: "Grupo", sortable: true },
                    { key: "PeriodName", label: "Período", sortable: true },
                    { key: "GeneralDescription", label: "Descripción general", sortable: false },
                    { key: "Status", label: "Estado", sortable: true },
                    { key: "CreatedByFormat", label: "Creación", sortable: true },
                    { key: "ModifiedByFormat", label: "Última modificación", sortable: true },
                    { key: "action", label: "Acciones", sortable: false },
                ],
                records: [] as IPiarModel[],
                rowsPerPage: 10,
            } as any,
        };
    },
    async mounted() {
        await this.load();
    },
    computed: {
        filteredItems(): IPiarModel[] {
            const search = this.table.filters.search?.toLowerCase() ?? "";

            if (!search) {
                return this.table.records;
            }

            return this.table.records.filter((item) => {
                return (
                    item.StudentName?.toLowerCase().includes(search) ||
                    item.CourseGroupName?.toLowerCase().includes(search) ||
                    item.PeriodName?.toLowerCase().includes(search) ||
                    item.GeneralDescription?.toLowerCase().includes(search)
                );
            });
        },
        rows(): number {
            return this.table.records?.length || 0;
        },
    },
    methods: {
        async load() {
            this.table.loading = true;
            try {
                // Usa el método de tu servicio (ajusta el nombre si lo llamaste distinto)
                this.table.records = await PiarService.GetAll();
            } finally {
                this.table.loading = false;
            }
        },
        openForm(Id: number) {
            // 0 = nuevo PIAR, >0 = editar
            router.push(`piar-basic-data/${Id}`);
        },
    },
});
